import _ from 'lodash';
import {
    FETCH_RAINPRO_PRODUCTS,
    CLEAN_RAINPRO_PRODUCTS,
    DELETE_RAINPRO_PRODUCT,
    CHANGE_RAINPRO_PRODUCT_STATUS,
    CHANGE_RAINPRO_PRODUCTS_STATUS,
    DELETE_RAINPRO_PRODUCTS,
} from './types';
import {request, __} from '../functions';

export const fetchRainproProducts = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
        callback: null,
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/rainpro/products', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        if (options.callback !== null) {
            // Zavolame callback
            options.callback();
        }

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_RAINPRO_PRODUCTS, payload: data });
    });
};

export const changeRainproProductsStatus = (screen, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/rainpro/multiChangeProductStatus/${ids}`, params).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť produkty'));
            return;
        }

        screen.showSnackbar('success', __('Produkty boli zmenené'));

        dispatch({ type: CHANGE_RAINPRO_PRODUCTS_STATUS });
    });
};

export const cleanRainproProducts = () => ({ type: CLEAN_RAINPRO_PRODUCTS });

export const changeRainproProductStatus = (screen, id, product_status) => {
    return dispatch => request(`/rainpro/changeProductStatus/${id}/${product_status}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť produkt'));
            return;
        }

        screen.showSnackbar('success', __('Produkt bol zmenený'));

        dispatch({ type: CHANGE_RAINPRO_PRODUCT_STATUS, payload: { id, status: product_status } });
    });
};

export const deleteRainproProduct = (screen, id) => {
    return dispatch => request(`/rainpro/removeProduct/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            // Objednavku sa nepodarilo zmazat
            screen.showSnackbar('error', __('Produkt sa nepodarilo zmazať'));
            return;
        }

        screen.showSnackbar('success', __('Produkt bol zmazaný'));

        dispatch({ type: DELETE_RAINPRO_PRODUCT });
    });
};

export const deleteRainproProducts = (screen, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/rainpro/multiDeleteProducts/${ids}`, params).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať produkty'));
            return;
        }

        screen.showSnackbar('success', __('Produkty boli zmazané'));

        dispatch({ type: DELETE_RAINPRO_PRODUCTS });
    });
};
